import React from 'react';
import { observer } from 'mobx-react';
import cx from 'classnames';
import styles from './BoolInput.m.sass';
var BooleanInput = function BooleanInput(_ref) {
  var _vm$answer;
  var vm = _ref.vm,
    disabled = _ref.disabled,
    _onChange = _ref.onChange;
  var answer = (_vm$answer = vm.answer) !== null && _vm$answer !== void 0 ? _vm$answer : vm.prompt.question.answer;
  var type = vm.prompt.question.type;
  return /*#__PURE__*/React.createElement("ul", {
    className: styles.boolInput,
    "data-test": 'prompt-dialog-answer-' + type
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("label", {
    className: cx(disabled && styles.disabled)
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: "answer",
    checked: answer === true,
    disabled: disabled,
    onChange: function onChange() {
      _onChange(true);
    },
    "data-test": "bool-answer-yes"
  }), "Yes")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("label", {
    className: cx(disabled && styles.disabled)
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: "answer",
    checked: answer === false,
    disabled: disabled,
    onChange: function onChange() {
      _onChange(false);
    },
    "data-test": "bool-answer-no"
  }), "No")));
};
export default observer(BooleanInput);
//# sourceMappingURL=index.js.map
